// Only public content detail routes. Never forward auth queries or editor routes.
export function contentAppUrl(pathname) {
  let parts;
  try {
    parts = pathname.replace(/\/$/, '').split('/').slice(1).map(decodeURIComponent);
  } catch {
    return null;
  }
  if (
    !pathname.startsWith('/') ||
    parts.some(
      (p) =>
        !p ||
        /[/?#\\]/.test(p) ||
        [...p].some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127) ||
        ['.', '..'].includes(p),
    )
  )
    return null;
  const [kind, id, third, fourth, fifth, sixth, seventh] = parts;
  const source = /^(local|apple_music|spotify|postpop)$/i.test(id);
  const number = (value) => /^[1-9]\d*$/.test(value || '');
  let supported = false;
  if (['feed', 'users'].includes(kind)) supported = parts.length === 2;
  if (kind === 'users' && id === 'by-id' && parts.length === 3)
    supported = number(third) && Number.isSafeInteger(Number(third));
  if (['lists', 'mixes', 'news', 'notice'].includes(kind)) {
    supported =
      !['create', 'new', 'edit'].includes(id) &&
      (parts.length === 2 || (parts.length === 4 && third === 'comment' && number(fourth)));
  }
  if (kind === 'artists')
    supported =
      parts.length === 2 || (parts.length === 3 && /^(apple_music|spotify|postpop)$/.test(id));
  if (kind === 'reviews') {
    supported =
      parts.length === 2 ||
      (source && parts.length === 3) ||
      (parts.length === 4 && third === 'user-reviews' && number(fourth)) ||
      (parts.length === 6 &&
        third === 'user-reviews' &&
        number(fourth) &&
        fifth === 'comment' &&
        number(sixth)) ||
      (source && parts.length === 5 && fourth === 'user-reviews' && number(fifth)) ||
      (source &&
        parts.length === 7 &&
        fourth === 'user-reviews' &&
        number(fifth) &&
        sixth === 'comment' &&
        number(seventh));
  }
  return supported ? `postpop://${parts.map(encodeURIComponent).join('/')}` : null;
}
